var _rect, _path, _path2, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 52,
    viewBox: "0 0 25 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.640738,
    y: 0.640738,
    width: 23.0562,
    height: 23.0562,
    rx: 7.35926,
    fill: "#6A27EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49011 11.9365H17.3827",
    stroke: "white",
    strokeWidth: 1.28148,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 6.49023L12.05 17.3828",
    stroke: "white",
    strokeWidth: 1.28148,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.640738,
    y: 0.640738,
    width: 23.0562,
    height: 23.0562,
    rx: 7.35926,
    stroke: "#6A27EA",
    strokeWidth: 1.28148
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91692 43.394H8.30254L5.14514 35.3302H3.81631L0.67026 43.394H2.05588L2.68055 41.7472H6.29225L6.91692 43.394ZM3.12349 40.5547L4.4864 36.9429L5.84931 40.5547H3.12349ZM13.1788 35.3302V38.4308H13.1561C12.9403 37.9651 12.1907 37.3745 11.1118 37.3745C9.71478 37.3745 8.24966 38.4081 8.24966 40.4411C8.24966 42.4741 9.71478 43.5076 11.1118 43.5076C12.1907 43.5076 12.9403 42.917 13.1561 42.4514H13.1902V43.394H14.4395V35.3302H13.1788ZM11.3503 42.3719C10.4076 42.3719 9.48763 41.7131 9.48763 40.4411C9.48763 39.169 10.4076 38.5103 11.3503 38.5103C12.3043 38.5103 13.2243 39.169 13.2243 40.4411C13.2243 41.7131 12.3043 42.3719 11.3503 42.3719ZM20.3328 35.3302V38.4308H20.3101C20.0943 37.9651 19.3447 37.3745 18.2657 37.3745C16.8687 37.3745 15.4036 38.4081 15.4036 40.4411C15.4036 42.4741 16.8687 43.5076 18.2657 43.5076C19.3447 43.5076 20.0943 42.917 20.3101 42.4514H20.3441V43.394H21.5935V35.3302H20.3328ZM18.5042 42.3719C17.5615 42.3719 16.6416 41.7131 16.6416 40.4411C16.6416 39.169 17.5615 38.5103 18.5042 38.5103C19.4582 38.5103 20.3782 39.169 20.3782 40.4411C20.3782 41.7131 19.4582 42.3719 18.5042 42.3719Z",
    fill: "#6A27EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.af73329dc08978f693ea8ef62aad36ab.svg";
export { ForwardRef as ReactComponent };